import { addZero } from './stringUtil';
import { WEEK_ENG_STR } from './constants';

export const getNowDateTimeStr = (val, type) => {
    var now = new Date();
    if (val && type) {
        if (type === "D") {
            now.setDate(now.getDate() + val);
        } else if (type === "H") {
            now.setHours(now.getHours() + val);
        }
    }
    return [
        now.getFullYear(),
        addZero(now.getMonth() + 1),
        addZero(now.getDate()),
        addZero(now.getHours()),
        addZero(now.getMinutes())
    ].join("");
};

export const getDatTime = (day, type) => {
    return getNowDateTimeStr(day, type);
};

export const getDate = (day, type) => {
    return getNowDateTimeStr(day, type).substring(0, 8);
};

export const getTime = (day, type) => {
    return getNowDateTimeStr(day, type).substring(8);
};

export const getHour = (day, type) => {
    return getNowDateTimeStr(day, type).substring(8, 10);
};

export const getToday = () => {
    var now = new Date();
    let timeStr = '';
    if (now.getHours() > 12) {
        timeStr = now.getHours() - 12;
        timeStr += ":" + (now.getMinutes() > 9 ? now.getMinutes() : "0" + now.getMinutes());
        timeStr += " PM";
    } else {
        timeStr = now.getHours();
        timeStr += ":" + (now.getMinutes() > 9 ? now.getMinutes() : "0" + now.getMinutes());
        timeStr += " AM";
    }
    return WEEK_ENG_STR[now.getDay()] + " " + timeStr;
};

export const getDateFormat = (dateStr) => {
    return dateStr.substring(0, 4) + "년 " + dateStr.substring(4, 6) + "월 " + dateStr.substring(6, 8) + "일";
};
